import { SyncResponse, SessionInitMessage, SessionCloseMessage, ErrorResponse } from '@augloop/session-protocol';
import { Operation as LogOperation, Log, LogCategory } from '@augloop/logging';
import { SchemaObject } from '@augloop/types-core';
import { ClientSendMessageErrorReason } from './message-queue';
export var SessionState;
(function (SessionState) {
    SessionState[SessionState["Initing"] = 0] = "Initing";
    SessionState[SessionState["Running"] = 1] = "Running";
    SessionState[SessionState["Disconnected"] = 2] = "Disconnected";
    SessionState[SessionState["Closed"] = 3] = "Closed";
})(SessionState || (SessionState = {}));
export const sendMessageNow = (context, message, onResponse, attemptNumber) => {
    if (!message) {
        return;
    }
    if (!message.cv) {
        message.cv = context.cvParent.newChild().toString();
    }
    context.messageEndpoint.sendMessage(message, (err, resp) => {
        // Record when was the last sync message response received
        if (!err && SchemaObject.getTypeNameFor(resp) === SyncResponse.getTypeName()) {
            context.stats.lastSyncMessage = Date.now();
        }
        if (onResponse) {
            onResponse(err, resp);
        }
    }, undefined, attemptNumber);
};
export const queueMessage = (context, message, onResponse, attemptNumber) => {
    if (!message) {
        return;
    }
    context.messageQueue.push(message, onResponse, attemptNumber);
    context.networkWorkerManager.init(undefined /*extensionConfigs*/, context.customInitPromise)
        .catch((e) => {
        const logOp = new LogOperation({ operationName: 'WorkerManagerInit', success: false, resultDescription: `${e}` });
        Log.error(0x1e54570d /* tag_4vf2n */, LogCategory.CoreDefault, logOp);
    });
};
export const queueBytes = (context, buffer) => {
    if (!buffer) {
        return;
    }
    context.messageQueue.push(buffer);
    context.networkWorkerManager.init(undefined /*extensionConfigs*/, context.customInitPromise)
        .catch((e) => {
        Log.error(0x1e54570c /* tag_4vf2m */, LogCategory.CoreDefault, `Init failed: ${e}`);
    });
};
export class BaseState {
    constructor(context) {
        this.context = context;
    }
    onEnter(_params) {
    }
    sendMessage(_message, _onResponse, _attemptNumber, _sendOnlyIfConnected) {
    }
    sendBytes(_buffer) {
    }
    canSendMessage() {
        return false;
    }
    onConnectionClose() {
    }
}
export class InitingState extends BaseState {
    constructor() {
        super(...arguments);
        this.stateName = SessionState.Initing;
        this.possibleNextStates = [SessionState.Running, SessionState.Disconnected, SessionState.Closed];
    }
    sendMessage(message, onResponse, attemptNumber) {
        if (SchemaObject.matchesTypesFor(message, [SessionInitMessage.getTypeName()])) {
            sendMessageNow(this.context, message, onResponse, attemptNumber);
        }
        else {
            queueMessage(this.context, message, onResponse);
        }
    }
    sendBytes(buffer) {
        queueBytes(this.context, buffer);
    }
    onConnectionClose() {
        this.context.setState(SessionState.Disconnected);
    }
}
export class RunningState extends BaseState {
    constructor() {
        super(...arguments);
        this.stateName = SessionState.Running;
        this.possibleNextStates = [SessionState.Disconnected, SessionState.Closed];
    }
    onEnter(params) {
        if (params && params.isSessionReseedingStarted) {
            this.context.resetNextSyncSequenceId();
        }
        this.context.messageQueue.sendOnSessionInitialized(params && params.isSessionReseedingStarted);
    }
    sendMessage(message, onResponse, attemptNumber, _sendOnlyIfConnected) {
        sendMessageNow(this.context, message, onResponse, attemptNumber);
    }
    sendBytes(buffer) {
        if (buffer) {
            void this.context.networkWorkerManager.egressBytes(buffer);
        }
    }
    canSendMessage() {
        return true;
    }
    onConnectionClose() {
        this.context.setState(SessionState.Disconnected);
    }
}
export class DisconnectedState extends BaseState {
    constructor() {
        super(...arguments);
        this.stateName = SessionState.Disconnected;
        this.possibleNextStates = [SessionState.Initing, SessionState.Closed];
    }
    onEnter(_params) {
        this.context.messageEndpoint.cancelPendingResponseCallbacks();
    }
    sendMessage(message, onResponse, attemptNumber, sendOnlyIfConnected) {
        if (SchemaObject.matchesTypesFor(message, [SessionInitMessage.getTypeName()])) {
            this.context.setState(SessionState.Initing);
            sendMessageNow(this.context, message, onResponse, attemptNumber);
        }
        else if (SchemaObject.matchesTypesFor(message, [SessionCloseMessage.getTypeName()])) {
            this.context.setState(SessionState.Closed);
        }
        else {
            if (!sendOnlyIfConnected) {
                queueMessage(this.context, message, onResponse, attemptNumber);
                return;
            }
            if (onResponse) {
                onResponse(new ErrorResponse({ messageId: message.messageId, error: ClientSendMessageErrorReason.DroppedBecauseClientDisconnected }));
            }
        }
    }
    sendBytes(buffer) {
        queueBytes(this.context, buffer);
    }
}
export class ClosedState extends BaseState {
    constructor() {
        super(...arguments);
        this.stateName = SessionState.Closed;
        this.possibleNextStates = [];
    }
    onEnter(_params) {
        this.context.messageEndpoint.cancelPendingResponseCallbacks();
    }
}
//# sourceMappingURL=session-states.js.map